import type { RtlItem } from '../../config-provider/src/internal-interface'
import rtlStyle from '../src/styles/avatar-group-rtl.cssr'

export const avatarGroupRtl: RtlItem = {
  name: 'AvatarGroup',
  style: rtlStyle
}
